import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AllItems from "../components/Views/AllItems.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import ViewForm from "../components/Views/ViewForm.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import Entity from "../datasource/Entity";
import axios from "axios";

import Container from "./Container.jsx";

class MarketCodesContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("market_codes");
        this.state = {
            marketGroups: [],
        };
    }

    getBackLink = () => this.datasource.routes().home;

    componentDidMount() {
        axios
            .get(`/manager/data/hotels/${this.props.hotelId}/market_groups`)
            .then((res) => {
                this.setState({ marketGroups: res.data });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    render = () => {
        const notPermitted = this.checkAvailability();
        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        const defaultHotels = this.props.defaultHotels?.map((hotel) => ({
            id: hotel.id,
            name: hotel.name,
            active: hotel.active,
        }));

        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title={"Торговые коды"}
                        columns={{
                            id: "Id",
                            name: "Имя",
                            code: "Код",
                            description: "Описание",
                            active: "Активен",
                            market_group_id: "Торговая группа",
                        }}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        viewAction={this.getViewLink}
                        editAction={this.getEditLink}
                        toggleAction={this.toggleItem}
                        removeAction={this.removeItem}
                        getHotelsAction={this.getHotelsData}
                        hotelsData={this.state.hotelsData}
                        defaultSortOrder={"desc"}
                        fields={fields}
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Торговый код"}
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addItem}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        setRelationsValue={this.setRelationsValue}
                        defaultHotels={defaultHotels}
                        interfaceTypes={this.state.marketGroups}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        title="Редактирование торгового кода"
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={fields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateItem}
                        submitActionApply={this.updateItemWithoutReload}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        defaultHotels={defaultHotels}
                        interfaceTypes={this.state.marketGroups}
                    />
                </Route>
            </Switch>
        );
    };
}

export default MarketCodesContainer;
